import React, { Fragment, useMemo } from 'react';
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import srImg from '../../images/services/service_image_8.webp' 
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import WhyUs from '../AboutUsPage/WhyUs';
import { useSeo } from '../../hooks/useSeo';
import CompleteServiceSection from '../../components/ServiceSection/ServiceCompleteSection';

const staticMeta = {
  title: 'Our Services | RashTech Info',
  description: 'Discover tailored IT services from RashTech Info: web, mobile, cloud, DevOps, UI/UX, and more to drive measurable growth.',
  url: 'https://rashtechinfo.com/service',
  image: 'https://rashtechinfo.com/og-image.png',
  siteName: 'RashTech Info',
  keywords: 'services, web development, mobile apps, cloud, DevOps, UI/UX, RashTech Info',
  themeColor: '#0A0D1C',
};

const ServicePage = () => {
  const { seo } = useSeo('/getSeo');
  console.log(seo);
  

  const computed = useMemo(() => {
    const dynamic = {
      title: seo?.title,
      description: seo?.metaDescription,
      keywords: seo?.metaKeywords,
      canonicalUrl: seo?.canonicalUrl,
    };
    return {
      title: dynamic.title || staticMeta.title,
      description: dynamic.description || staticMeta.description,
      keywords: dynamic.keywords || staticMeta.keywords,
      url: dynamic.canonicalUrl || staticMeta.url,
      image: staticMeta.image,
      siteName: staticMeta.siteName,
      themeColor: staticMeta.themeColor,
    };
  }, [seo]);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }

  return (
    <Fragment>
      <Helmet>
        <title>{computed.title}</title>
        <meta name="description" content={computed.description} />
        {computed.keywords && <meta name="keywords" content={computed.keywords} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content={computed.themeColor} />
        {computed.url && <link rel="canonical" href={computed.url} />}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={computed.siteName} />
        <meta property="og:title" content={computed.title} />
        <meta property="og:description" content={computed.description} />
        {computed.url && <meta property="og:url" content={computed.url} />}
        {computed.image && <meta property="og:image" content={computed.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={computed.title} />
        <meta name="twitter:description" content={computed.description} />
        {computed.image && <meta name="twitter:image" content={computed.image} />}
      </Helmet>

      <Header />
      <main className="page_content about-page">
        <PageTitle pageTitle={'Our Services'} pagesub={'Services'} pageTop={'Our Main'} />
        <section className="about_section section_space bg-light">
          <div className="container">
            <div className="row align-items-center justify-content-lg-between">
              <div className="col-lg-5 order-lg-last">
                <div className="team_cartoon_image">
                  <img src={srImg} alt="Service Cartoon"/>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="about_content">
                  <div className="heading_block">
                    <div className="heading_focus_text">
                      We Are
                      <span className="badge bg-secondary text-white">IT Guidance</span>
                    </div>
                    <h2 className="heading_text">
                      Innovative IT Solutions for Your Success
                    </h2>
                    <p className="heading_description mb-0">
                      
Every business is different, with unique challenges and ambitions. We provide innovative IT solutions crafted to help you achieve long-term success.
                    </p>
                  </div>
                  <Link onClick={ClickHandler} to={'/contact'} className="btn">
                    <span className="btn_label" data-text="Talk to an Expart">Talk to an Expart</span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CompleteServiceSection />
        <div className="pt-130"></div>
        <WhyUs />
        
      </main>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
};
export default ServicePage;



